import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import styled from '@emotion/styled'

import ServiceCard from './ServiceCard'
import AllServiceCard from './AllServiceCard'

const ServiceLayoutWrapper = styled(Box)`
  ${({ theme }) => `
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  min-height: 180px;
  height: auto;

    ${theme.breakpoints.up('md')} {
      width: 704px;
      maxwidth: 704px;
      min-height: 276px;
      padding-left: 0px;
      padding-right: 0px;  
      margin: 32px auto;
    }

    ${theme.breakpoints.up('lg')} {
      width: 770px;
      maxwidth: 770px;
      min-height: 140px;
      flex-direction: row;
      margin: 40px auto;
    }

    ${theme.breakpoints.up('xl')} {
      min-height: 164px;
      width: 916px;
      maxwidth: 916px;    
    }

    ${theme.breakpoints.up('xxl')} {
      min-height: 218px;
      width: 1222px;
      maxwidth: 1222px;
    }
  `}
`

const ServiceCardWrapper = styled(Box)`
  ${({ theme }) => `
  width: 100%;

    ${theme.breakpoints.up('lg')} {
      width: calc(100% - 156px);
    }

    ${theme.breakpoints.up('xl')} {
      width: calc(100% - 188px);
    }

    ${theme.breakpoints.up('xxl')} {
      width: calc(100% - 250px);
    }
  `}
`

const ServiceLayout = ({ openAllServiceModal, containerId, catalogsData }) => {
  return (
    <ServiceLayoutWrapper>
      <AllServiceCard openAllServiceModal={openAllServiceModal} />
      <ServiceCardWrapper>
        <Grid
          container
          rowSpacing={{ xs: 2, md: 4, xl: 6, xxl: 8 }}
          columnSpacing={{ xs: 2, md: 4, xl: 6, xxl: 8 }}
        >
          {catalogsData?.map((catalog) => {
            return (
              <Grid item xs={6} md="auto" key={catalog._id}>
                <ServiceCard
                  catalogData={catalog}
                  lazy={true}
                  lazyOptions={{ containerId }}
                />
              </Grid>
            )
          })}
        </Grid>
      </ServiceCardWrapper>
    </ServiceLayoutWrapper>
  )
}

export default ServiceLayout
